<form>
  <div class="light-blue-text card-title">Palvelukokonaisuus</div>

  <div class="section">
    <div class="section-title">Palvelupaketit</div>

    <mat-radio-group [formField]="lomake.palvelupaketti">
      @for (palvelupaketti of palvelupaketit; track palvelupaketti) {
        <mat-radio-button [value]="palvelupaketti.value">{{ palvelupaketti.name }}</mat-radio-button>
      }
    </mat-radio-group>
    @if ((lomake.palvelupaketti().dirty() || lomake.palvelupaketti().touched()) && onkoVirhe(lomake.palvelupaketti, 'required')) {
      <mat-error>Valitse palvelupaketti</mat-error>
    }
  </div>
  <div class="section">
    <div class="section-title">Lisäpalvelut</div>

    <div style="display: flex">
      <!-- <div>
      <div>Kirjanpidon lisäpalvelut:</div>
      <mat-checkbox formControlName="ennakkoverojenSeuranta">Ennakkoverojen seuranta</mat-checkbox>

      <div style="margin-top: 10px;">Ostolaskut:</div>
      <mat-checkbox formControlName="ostolaskujenMaksaminen">Ostolaskujen maksaminen</mat-checkbox>
      <mat-checkbox formControlName="kirjanpidonReskontra">Reskontran hoito (kirjanpito)</mat-checkbox>
    </div> -->

      <div>
        <div>Palkanlaskenta:</div>
        <mat-checkbox [formField]="lomake.palkat">Palkat palvelu</mat-checkbox>

        <!-- <div>Myyntilaskutus:</div>
      <mat-checkbox formControlName="myyntilaskujenLahettaminen">Myyntilaskujen lähettäminen</mat-checkbox>
      <mat-checkbox formControlName="reskontranHoito">Reskontran hoito</mat-checkbox>
      <mat-checkbox formControlName="saatavienValvonta">Saatavien valvonta</mat-checkbox> -->
      </div>
    </div>
  </div>

  @if (!hideVoimassaAlkaen) {
    <div class="section">
      <div class="section-title">Voimassa alkaen</div>
      <mat-form-field style="width: 200px">
        <mat-label>Voimassa alkaen</mat-label>
        <input [formField]="lomake.sopimusversioVoimassaAlkaen" type="text" [matDatepicker]="picker3" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
        <mat-datepicker #picker3 startView="year"></mat-datepicker>
        @if (onkoVirhe(lomake.sopimusversioVoimassaAlkaen, 'minDate')) {
          <mat-error>Täytyy alkaa aikaisintaan sopimuskauden alusta ja myöhemmin kuin viimeisin versio</mat-error>
        }
      </mat-form-field>
    </div>
  }
</form>
